import { Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";

import ModeEditOutlineOutlinedIcon from '@mui/icons-material/Cancel';

import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import ArticleIcon from '@mui/icons-material/Article';
import WorkspacesOutlinedIcon from '@mui/icons-material/WorkspacesOutlined';
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";



const ParentRollActionMenu = ({ selectedButtonName, setSelectedButtonName, handlecallProcess, enableRejectParentRoll }) => {
    const userPermissions = useUserPermissions();
    const [selectedButton, setSelectedButton] = useState(null);
    const [viewParentRollDetail, setViewParentRollDetail] = useState(false);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);

        handlecallProcess(buttonName);
        if (buttonName === 'PDF') {
            setViewParentRollDetail(true);
        }
        else if (buttonName === 'ViewParentRollDetail') {
            setViewParentRollDetail(false);
        }

        if (buttonName == 'QRCode' && viewParentRollDetail === false) {
            setViewParentRollDetail(true);
        }

    };
    return (

        <Grid container display="flex-start" padding={0}>

            {/* Add Button */}

            {hasPermission(userPermissions, "Paper Machine Production", "Delete") && (


                <div>
                    <Grid item md={0} ml="1px" mr="1px">
                        <Tooltip title="Back to menu">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <IconButton onClick={() => handleButtonClick('Reject')} disabled={enableRejectParentRoll}  >
                                    <ModeEditOutlineOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'Reject' ? "yellow" : "#009688" }} />
                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Reject Parent Roll</Typography>
                                </IconButton>
                            </div>
                        </Tooltip>
                    </Grid>
                    {/* <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                </div>
            )}
            {/* Add Button */}

            {hasPermission(userPermissions, "Paper Machine Production", "View") && (

                <div>
                    <Grid item md={0} ml="5px" mr="5px">
                        <Tooltip title="Add new orders">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <IconButton onClick={() => handleButtonClick('QRCode')}>
                                    <ReceiptRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'QRCode' ? "yellow" : "#009688" }} />
                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Print QR Code</Typography>
                                </IconButton>

                            </div>
                        </Tooltip>
                    </Grid>



                    {/* <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                </div>
            )}

            {/* Add Button */}
            {viewParentRollDetail && (
                <>
                    <Grid item md={0} ml="5px" mr="5px">
                        <Tooltip title="Add new orders">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <IconButton onClick={() => handleButtonClick('ViewParentRollDetail')}>
                                    <ArticleIcon style={{ fontSize: "18px", color: selectedButton === 'ViewParentRollDetail' ? "yellow" : "#009688" }} />
                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>View Parent Roll Details</Typography>
                                </IconButton>
                                {/* <span style={{ fontSize: 12 }}>PDF/Print</span> */}
                            </div>
                        </Tooltip>
                    </Grid>
                    {/* <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                </>
            ) || (
                    <>
                        {hasPermission(userPermissions, "Paper Machine Production", "View") && (


                            <div>
                                <Grid item md={0} ml="5px" mr="5px">

                                    <Tooltip title="Add new orders">
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <IconButton onClick={() => handleButtonClick('PDF')}>
                                                <PictureAsPdfOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'PDF' ? "yellow" : "#009688" }} />
                                                <Typography variant="h6" sx={{ marginLeft: "5px" }}>Report</Typography>
                                            </IconButton>
                                            {/* <span style={{ fontSize: 12 }}>PDF/Print</span> */}
                                        </div>
                                    </Tooltip>
                                </Grid>


                                {/* <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}
                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                            </div>
                        )}

                    </>
                )}



            {/* Add Button */}
            {hasPermission(userPermissions, "Winder Machine Production", "Enabled") && (


                <div>
                    <Grid item md={0} ml="5px" mr="5px">
                        <Tooltip title="Add new orders">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <IconButton onClick={() => handleButtonClick('WinderMachine')}>
                                    <ExitToAppRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'WinderMachine' ? "yellow" : "#009688" }} />
                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>Winder Machine Production</Typography>
                                </IconButton>
                                {/* <span style={{ fontSize: 12 }}>Receive</span> */}
                            </div>
                        </Tooltip>
                    </Grid>
                    {/* <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                </div>
            )}


            {hasPermission(userPermissions, "Paper Machine Production", "View") && (
                <div>
                    <Grid item md={0} ml="5px" mr="5px">
                        <Tooltip title="Add new orders">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <IconButton onClick={() => handleButtonClick('ChildRoll')}>
                                    <WorkspacesOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'ChildRoll' ? "yellow" : "#009688" }} />
                                    <Typography variant="h6" sx={{ marginLeft: "5px" }}>View Child Rolls List</Typography>
                                </IconButton>
                                {/* <span style={{ fontSize: 12 }}>Receive</span> */}
                            </div>
                        </Tooltip>
                    </Grid>
                    {/* <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />



                </div>

            )}

            {/* <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Add new orders">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('MAWiseBalanceQty')}>
                            <WorkspacesOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'MAWiseBalanceQty' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>View MA Wise Balance Qty</Typography>
                        </IconButton>
                      
                    </div>
                </Tooltip>
            </Grid>
            
            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} /> */}

        </Grid>

    )
};
export default ParentRollActionMenu;